import Loader from "@/Loader"
const Preloader = () => {
  return (
    <>
      <Loader />
    </>
  )
}

export default Preloader
